<template>
  <div class="full-height">
    <ld-header>
      客服
    </ld-header>
    <div class="qgehomewrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <van-cell @click="kfShow = true">
          <van-row
            type="flex"
            align="center"
          >
            <van-col
              span="4"
              style="line-height: initial;"
            >
              <img :src="kf">
            </van-col>
            <van-col span="18">
              电话客服
            </van-col>
            <van-col span="2">
              <van-icon
                class="font16 van-cell__right-icon"
                name="arrow"
              />
            </van-col>
          </van-row>
        </van-cell>
        <van-cell
          v-show="url"
          @click="toWeChat"
        >
          <van-row
            type="flex"
            align="center"
          >
            <van-col
              span="4"
              style="line-height: initial;"
            >
              <img :src="weChat">
            </van-col>
            <van-col
              span="18"
              class="black"
            >
              在线客服
            </van-col>
            <van-col span="2">
              <van-icon
                class="font16 van-cell__right-icon"
                name="arrow"
              />
            </van-col>
          </van-row>
        </van-cell>
      </mescroll-vue>
    </div>
    <service-list :visibility.sync="kfShow" height="20%"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Icon, Cell, Image as VanImage, Tag, Dialog } from 'vant'
import ServiceList from 'Components/ServiceList'
import MescrollVue from 'mescroll.js/mescroll.vue'
// import { loadChat,normalChat } from 'CommonUtils/chat'
import { getSysParameter } from 'Utils/publicApi'
import { isH5 , isIOS , isAndroid } from 'CommonUtils/plus'
import { openWebview } from '@/common/utils/plus'

import kf from 'Components/Dynamic/btlh/images/service/kf.png'
import weChat from 'Components/Dynamic/btlh/images/service/weChat.png'

export default {
  name: 'Home',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    ServiceList,
    MescrollVue,
  },
  data () {
    return {
      down: { use: false },
      kfShow: false,
      kf,
      weChat,
      orderList: [],
      gidMdk:'',
      url:'',
      identer:'',
      accountid:'',
      isWx:false
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices'])
  },
  created () {
  },
  mounted () {
    //在线客服
    this.$api['user/getCustomerInfoList']({}).then(res=>{
      if(res.data){
        this.gidMdk = res.data[0].gidMdk
      }
    })
    getSysParameter('11605065').then(res=>{
      if(res.value1){
        this.identer=res.value1
        this.url=res.value2
      }else{
        this.kfShow = true
      }
    })
    getSysParameter('11605037').then(res=>{
      if(res.value1){
        res.value1==0?this.isWx=false:this.isWx=true
      }
    })
  },
  methods: {
    toWeChat() {
      if (!this.url || this.url == 0) {
        Dialog.alert({
          message: '在线聊天未配置，请使用电话客服联系',
        }).then(() => {
          // on close
        })
        return
      }
      if (isH5() || isAndroid()) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          if (ua.indexOf('miniprogram') !== -1) {//小程序
            console.log("小程序")
            let d = {
              corpId: this.identer,//企业微信ID
              url: this.url,//企业微信客户接入链接
            }
            let p = Object.keys(d).reduce((p, k, i) => p + `${i ? '&' : '?'}${k}=${d[k]}`, '');
            wx.miniProgram.reLaunch({url: `/pages/index/index${p}`});//触发小程序刷新页面获取appId
          } else {
            console.log("微信")
            location.href = this.url
          }
        } else {
          if (this.isWx) {
            var iframe = document.createElement('iframe')
            iframe.src = this.url
            iframe.height = 0
            iframe.width = 0
            document.body.appendChild(iframe)
            iframe.onload = function () {
              console.log(arguments)
            }
          } else {
            /*
              visitorid参数，参数值为访客id
              visitorname参数，参数值为访客名称
              ctag参数，参数值为参数值为自定义传参
              gid:客服组id
            */
            const {empId, empName, phoneNumber} = this.userInfo.empInfo
            const {corpNo, shortname} = this.userInfo.vipCorp
            const {gidMdk} = this
            location.href = this.url + '&visitorid=' + empId + '&visitorname=' + shortname + ' ' + empName + '  ' + phoneNumber + '&gid=' + gidMdk + '&ctag=' + corpNo
          }
        }
      } else if (isIOS()) {
        openWebview(this.url, 'towechat', '', '', '', function () {
          setTimeout(function () {
            plus.webview.close('towechat')
          }, 5000)
        })
      }
    },
    // initChat(){
    // 	if(!this.url||!this.accountid) return
    // 	loadChat({url:this.url,accountid:this.accountid,gid:this.gidMdk})
    // },
    // normalChat,
    ...mapActions(['getLoginNotice']),
  },
}
</script>

<style lang="less" scoped>
.qgehomewrapper {
  height: calc(100vh - 80px);
  overflow: hidden;
}
.qgehome {
  position: relative;
  padding: 30px 10px 10px;
  .box {
    padding: 0 5px;
  }
  .welcome {
    position: absolute;
    top: 100px;
    left: 15px;
  }

  .home-notice {
    position: absolute;
    top: 66px;
    left: 15px;
    width: calc(100% - 29px);
  }

  .server {
    position: absolute;
    top: 15px;
    right: 17px;
    color: @color-text-white;
    font-size: 24px;

    > p {
      margin-top: -5px;
    }
  }
}
</style>
